import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Switch } from 'antd';
import { useSession } from 'components/Authenticated';
import { txt } from 'libs/i18n';
const Citation = ({ value, onChange, label, disabled, tooltip, }) => {
    const { session } = useSession();
    const isSpeakerIdEnabled = session.login.hasClaim('speakerId:enabled');
    if (!isSpeakerIdEnabled) {
        return null;
    }
    return (_jsx(Form.Item, { label: label !== null && label !== void 0 ? label : txt('replaceWithCitation'), tooltip: tooltip, children: _jsx(Switch, { size: "small", disabled: disabled, checked: value, onChange: onChange }) }));
};
export default Citation;
